/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from "next/link";
import { useRouter } from "next/router";
import { getLinkProps } from "../../../util/url/getLinkProps";
import HiddenButton from "../../design-system/buttons/HiddenButton";

function RenderLink(props: any) {
  const {
    href, asPath, label = "", title = "", onClick = () => {}, className = "", labelFallback = "-",
  } = props;
  // show link, when there is no filters
  const router = useRouter();

  if (asPath?.indexOf("?") === -1) {
    return (
      <HiddenButton>
        <Link
          {...getLinkProps({ url: asPath })}
          onClick={onClick}
          className={className}
          title={title || (typeof label === "string" ? label : labelFallback)}
          data-clarity-unmask="true"
        >

          { label }

        </Link>
      </HiddenButton>
    );
  }
  return (
    <HiddenButton
      onClick={(e: any) => {
        onClick(); // Added for AMP detect >13
        e.preventDefault();
        if (e.ctrlKey) {
          window.open(asPath, "_blank");
        } else {
          router.push(href, asPath);
        }
      }}
    >

      <a
        className={className}
        title={title || (typeof label === "string" ? label : labelFallback)}
        data-clarity-unmask="true"
      >
        { label }
      </a>
    </HiddenButton>
  );
}

export default RenderLink;
